import { render, staticRenderFns } from "./DashboardSalesTable.vue?vue&type=template&id=60eedd88"
import script from "./DashboardSalesTable.vue?vue&type=script&lang=js"
export * from "./DashboardSalesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports